import { createFileRoute } from "@tanstack/react-router";
import AdminTermDetailPage from "@/pages/admin/terms/detail";
import { useTermsPermissions } from "@/pages/admin/terms";

export const Route = createFileRoute("/app/admin/terms/$termId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { termId } = Route.useParams();
  const { userCanEditAllTerms, userCanViewAllTerms } = useTermsPermissions();

  return (
    <AdminTermDetailPage
      termId={Number(termId)}
      userCanEditAllTerms={userCanEditAllTerms}
      userCanViewAllTerms={userCanViewAllTerms}
    />
  );
}
